import { type IColumn, Typography } from 'shared/ui'
import { EmptyCell } from 'shared/ui/TableNew'
import { DayjsFormats, getLabelAsNumberInternationalFormat } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { type ReviewContactRow } from 'entities/Review'
import { getCellForTags } from 'widgets/ContactEnrollment/ui/EnrollmentContactsTable'
import { ReviewContactNameCell } from 'pages/reviews/pages/viewReview/ui/ReviewContactsTable/ReviewContactNameCell'

export const clickedColumns: IColumn<ReviewContactRow>[] = [
  {
    field: 'full_name',
    name: 'Name',
    isDisabledChangeVisible: true,
    isSortable: true,
    width: '100%',
    minWidth: 266,
    maxWidth: 266,
    renderRowCell: (row, _, config) => <ReviewContactNameCell row={row} config={config} />,
  },
  {
    field: 'number',
    name: 'Number',
    width: '129px',
    minWidth: '129px',
    renderRowCell: ({ formattedNumber }) =>
      formattedNumber ? (
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactNumber'}>
          {getLabelAsNumberInternationalFormat(formattedNumber)}
        </Typography>
      ) : (
        <EmptyCell />
      ),
  },
  {
    field: 'short_url_last_clicked_at',
    name: 'Clicked at',
    width: '170px',
    minWidth: '170px',
    renderRowCell: ({ shortUrlLastClickedAt, lastClickedAt }) => {
      const clickedAt = shortUrlLastClickedAt ?? lastClickedAt

      if (!clickedAt) return <EmptyCell />

      return (
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactClickedAt'}>
          {uiStore.dayjs(clickedAt).format(DayjsFormats.fullWithAtDash)}
        </Typography>
      )
    },
  },
  {
    field: 'tags',
    name: 'Tags',
    renderRowCell: (row) => getCellForTags({ tags: row.tags, isDisabled: row.isDisabled }),
  },
]
